module.exports = __webpack_public_path__ + "static/under_construction-acdc9d656b1244c61f04b315299b2c81.png";